/**
 * @file src/components/VidButtonBank/SupportContents/SupportContentsStyles.tsx
 * @exports SlideInBox, ContentBox, Instructions, Title, Description, FormBox, IconWrapper, MessageBox, ButtonBox, CloseButton
 * @summary styled-components for SupportContents component
 */

import { colors } from "@cerebruminc/cerebellum";
import styled from "styled-components";

export const SlideInBox = styled.div<{ $fullScreen?: boolean }>`
    position: relative;
    background-color: ${colors.WHITE};
    border-radius: 20px;
    box-sizing: border-box;
    box-shadow: ${({ $fullScreen }) => ($fullScreen ? "none" : "0 6px 18px 0 rgba(146,151,182,0.39)")};
    display: flex;
    flex-flow: column nowrap;
    gap: 10px;
    max-height: ${({ $fullScreen }) => ($fullScreen ? "100vh" : "calc(90vh - 88px)")};
    overflow: auto;
    padding: 30px 30px 20px;
    width: 100%;

    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
    }
    &::-webkit-scrollbar-track {
        width: 7px;
        height: 7px;
    }

    &::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      transparent calc(0% + 20px),
      ${colors.COOL_GREY_20} calc(0% + 20px) calc(100% - 20px),
      transparent calc(100% - 20px)
    );
    cursor: pointer;
    min_height: 36px;
    width: 10px;

  }
  &::-webkit-scrollbar-thumb:horizontal {

    background-image: linear-gradient(
      90deg,
      transparent calc(0% + 20px),
      ${colors.COOL_GREY_20} calc(0% + 20px) calc(100% - 20px),
      transparent calc(100% - 20px)
    );
  }
`;

export const ContentBox = styled.div<{ $fullScreen?: boolean }>`
  margin-top: ${({ $fullScreen }) => ($fullScreen ? "50px" : "0")};
  height: 100%;
`;

export const Instructions = styled.div`
    margin-bottom: 30px;
    display: flex;
    flex-flow: column nowrap;
    gap: 10px;
`;

export const Title = styled.h2`
    color: ${colors.BLACK};
    font-size: 20px;
    font-weight: 800;
    line-height: 27px;
`;
export const Description = styled.span`
    color: ${colors.BLACK};
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
`;

export const FormBox = styled.div`
  margin-top: -20px;
`;

export const IconWrapper = styled.div`
    display: grid;
    height: 160px;
    margin-top: 10%;
    min-height: 100px;
    min-width: 160px;
    place-items: center;
    width: 100%;
`;

export const MessageBox = styled.div`
    display: grid;
    gap: 15px;
    margin-top: 8%;
    place-items: center;
    text-align: center;
    width: 100%;
`;

export const ButtonBox = styled.div`
    margin-top: 8%;
    width: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;
